import React from 'react';

function CameraIcon() {
    return <svg
        className="appointment-starting-icon"
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>0A3EF597-1CC8-4E9D-9041-279371B15A5A@1,5x</title>
        <g
            id="08---Consultas-Online"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd">
            <g
                id="MY-D-08-03-01"
                transform="translate(-1011.000000, -491.000000)">
                <g
                    id="Group-2"
                    transform="translate(382.000000, 452.000000)">
                    <g
                        id="WEB/CARDS/Doctors/Call"
                        transform="translate(0.000000, 30.000000)">
                        <g
                            id="COMPONENTS/PARTS/Consultas/Agora"
                            transform="translate(629.000000, 9.000000)">
                            <path
                                d="M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z"
                                id="Oval-background"
                                fill="#00B1D1"
                                fillRule="nonzero"></path>
                            <g
                                id="MUTUAL/ICONS/Camera/Standard"
                                transform="translate(12.695312, 14.257812)"
                                fill="#FFFFFF">
                                <path
                                    d="M14.6951191,0.780473334 L11.5195459,2.94408766 L11.5195459,2.24596643 C11.5195459,1.00555342 10.6711605,0 9.62462402,0 L1.89492187,0 C0.848385421,0 0,1.00555342 0,2.24596643 L0,9.23840857 C0,10.4788216 0.848385421,11.484375 1.89492187,11.484375 L9.62462402,11.484375 C10.6711605,11.484375 11.5195459,10.4788216 11.5195459,9.23840857 L11.5195459,8.54028734 L14.6951191,10.7039017 C15.2967568,11.1137905 15.7910156,10.7768956 15.7910156,9.95524619 L15.7910156,1.53287209 C15.7910156,0.707479425 15.2983359,0.370584461 14.6951191,0.780473334 Z"
                                    id="lists/icon_camera-small"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}
export default CameraIcon;